import api from './api.js';
import { AccordionsGroup } from './scripts/accordion/accordions-group.js';

api.AccordionsGroup = AccordionsGroup;

export default api;
